import { Injectable } from "@angular/core";
import { CryptoDepositRemote } from "@modules/+new/payments/features/crypto-deposit/domain/infrastructure/crypto-deposit.remote";
import { map, shareReplay } from "rxjs/operators";
import { combineLatest } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class CryptocoinsState {
	public cryptoSettings$ = this.cryptoDepositRemote
		.getAssetSettings()
		.pipe(shareReplay({ refCount: true, bufferSize: 1 }));

	public cryptocoins = this.cryptoDepositRemote
		.getDepositCryptocoins()
		.pipe(shareReplay({ refCount: true, bufferSize: 1 }));

	private unsortedAvailableDepositCryptoList$ = this.cryptocoins.pipe(
		map((list) => list.filter((item) => item.deposit_operational)),
		shareReplay({ refCount: true, bufferSize: 1 })
	);

	public availableCryptoWithdrawalList$ = this.cryptocoins.pipe(
		map((list) => list.filter((item) => item.withdraw_operational)),
		shareReplay({ refCount: true, bufferSize: 1 })
	);

	public availableCryptoDepositList$ = combineLatest([
		this.unsortedAvailableDepositCryptoList$,
		this.cryptoSettings$
	]).pipe(
		map(([cryptoList, cryptoSettings]) => {
			const cryptoSettingsMap = cryptoSettings.reduce((map, setting) => {
				map[setting.getId()] = setting.getSort() || 0;
				return map;
			}, {});
			return cryptoList.sort((crypto1, crypto2) => {
				const sortSetting1 = cryptoSettingsMap[crypto1.cryptocoin_id.toString()];
				const sortSetting2 = cryptoSettingsMap[crypto2.cryptocoin_id.toString()];
				return sortSetting1 - sortSetting2;
			});
		})
	);

	public sortedCryptoListForContacts$ = combineLatest([this.cryptocoins, this.cryptoSettings$]).pipe(
		map(([cryptoList, cryptoSettings]) => {
			cryptoList = cryptoList.filter(
				(crypto) =>
					!cryptoSettings
						.find((setting) => setting.getId() === crypto.cryptocoin_id.toString())
						?.isIndexOnly()
			);
			const cryptoSettingsMap = cryptoSettings.reduce((map, setting) => {
				map[setting.getId()] = setting.getSort() || 0;
				return map;
			}, {});

			const sorted = cryptoList.sort((crypto1, crypto2) => {
				const sortSetting1 = cryptoSettingsMap[crypto1.cryptocoin_id.toString()] || Infinity;
				const sortSetting2 = cryptoSettingsMap[crypto2.cryptocoin_id.toString()] || Infinity;
				return sortSetting1 - sortSetting2;
			});
			return sorted;
		})
	);

	constructor(private readonly cryptoDepositRemote: CryptoDepositRemote) {}
}
